import { EnumActionsPermissions } from '@models/EnumPermissions';
import { NavController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { EnumWalletModules } from '@models/Common';
import { IProjectSettings } from '@models/ProjectSettings';
import { ProjectService } from '@services/project.service';
import { StringUtils } from '@utils/StringUtils';
import { EnumAppMenu } from '@models/AppMenus';

@Component({
    selector: 'side-card-details',
    templateUrl: './side-card-details.component.html',
    styleUrls: ['./side-card-details.component.scss'],
})
export class SideCardDetailsComponent implements OnInit {

    @Input('data') Data: any;
    @Input('balance') Balance: any[] = [];
    @Input('projectSettings') ProjectSettings: IProjectSettings;

    @Input('movements') Historic: any[] = [];
    @Input('totalRegists') TotalRegists: number = 0;
    @Input('loadMore') OnLoadMore: Function;
    @Input('showToast') showToast: Function;

    public EnumActionsPermissions = EnumActionsPermissions;

    public HasSocialWallet: boolean = false;

    constructor(private NavController: NavController) {

    }

    ngOnInit() {

        console.log(this.Data, this.ProjectSettings);

        this.HasSocialWallet = this.Data?.Modules?.find(it => Number(it?.Id) == EnumWalletModules.SocialWallet);

        // for (let index = 0; index < 10; index++) {
        //     const element = {
        //         Name: `test_${index}`,
        //         CreateDate: new Date().toISOString()
        //     };

        //     this.Historic.push(element);
        // }
    }

    OnView(ev: any, item) {
        ev?.preventDefault();
        ev?.stopPropagation();

        console.log(item);

        if (item?.Type?.Id != '2') return;

        this.NavController.navigateForward([EnumAppMenu.MerchantsConsumptionsView, item?.Id], { animated: true });
    }

}
